import { NgModule } from '@angular/core';
import { SharedModule } from '../sharedModule/sharedModule.module';
import { PublicChatSupportComponent } from './public-chat-support.component';

@NgModule({
  imports: [SharedModule],
  declarations: [PublicChatSupportComponent],
  exports: [PublicChatSupportComponent],
})
export class PublicChatSupportModule {}
